import React, { useState, useEffect } from 'react';
import { Stack } from '@mui/material';
import ResultsByPlayerTable from '../tables/ResultsByPlayerTable';

import Subtitle from '../ui/Subtitle';
import { backendFetch } from '../../backend/backend';

const ResultsPage = () => {
	const [resultsTable,setResultsTable]=useState([]);
	const [playersList,setPlayersList]=useState([]);
	const [fetched,setFetched]=useState(false);

	useEffect(()=>{
		async function fetchData() {
			const players=await backendFetch('players?active=true');
			setPlayersList(players);
			const results=await backendFetch('results?season=active');
			setResultsTable(results);
			setFetched(true);
		}
		fetchData();
	},[]);

	return(
		<Stack spacing="0">
			<Subtitle text="Results" />
			{ fetched && <ResultsByPlayerTable playersList={playersList} resultsTable={resultsTable} /> }
		</Stack>
	);
}

export default ResultsPage;